import React, { useState, useEffect } from "react";
import Rightcontainer from "../Components/Rightcontainer";
import socket from "../Components/socket";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { apiRequest } from "../store/allApi";

const Gamehistory = ({ TicketList, Conversation }) => {
  // console.log(Conversation)
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const [user, setUser] = useState();
  let limit = 50;
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  let history = useHistory();

  const role = async () => {
    socket.emit("getprofile");

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest("me", "GET", null, headers);
      setUser(res.data);

      //Allgames(res.data._id)
      Allgames(res.data._id, pageNumber, limit);
      // window.location.reload()
    } catch (e) {}
  };

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
    // scroll to the top
    //window.scrollTo(0, 0)
  };
  const [game, setGame] = useState([]);
  // console.log(game)

  const Allgames = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    setIsLoading(true);

    try {
      const res = await apiRequest(
        `game/history/user/${id}?page=${pageNumber}&_limit=${limit}`,
        "GET",
        null,
        headers,
      );
      let gameHis = [];
      res.data.data.forEach((ele) => {
        if (
          ele.Status == "completed" ||
          ele.Status == "cancelled" ||
          ele.Status == "conflict"
        ) {
          gameHis.push(ele);
        }
      });
      setGame(gameHis);
      setNumberOfPages(res.data.totalPages);
      setIsLoading(false);
    } catch (e) {}
  };
  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
    return newDate;
  };

  useEffect(() => {
    role();
    //eslint-disable-next-line
  }, [pageNumber, limit]);

  // All history Api

  // UserList

  const UserList = (id) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      `Bearer ${localStorage.getItem("token")}`,
    );

    var urlencoded = new URLSearchParams();
    // urlencoded.append("agent_id", "63b5340bc5d2b82e4652b216");
    urlencoded.append("supportType", "game");
    urlencoded.append("issue", id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(baseUrl + "chat/genrate-ticket", requestOptions).then((response) =>
      response.json(),
    );
    // toggleWidget()
    TicketList();
    Conversation();

    toast
      .success("Your Ticket Generate Sucessfully")
      .then((result) => console.log(result));
    toast
      .error("Something Went Wrong")
      .catch((error) => console.log("error", error));
  };

  return (
    <div>
      <div
        className="leftContainer mb_space"
        style={{ height: "100%", paddingTop: "0px", paddingbottom: "0px" }}
      >
        <div className="  p-0 m-0 Orher_page_main_section">
          {/* <h2 className='profile_headings'>Game History</h2> */}

          {/* pagination */}

          {/* <div className=''>
            <div className=''>
              <ReactPaginate
                previousLabel={'Previous'}
                nextLabel={'Next'}
                breakLabel={'...'}
                pageCount={numberOfPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={'pagination justify-content-center'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                previousClassName={'page-item'}
                previousLinkClassName={'page-link'}
                nextClassName={'page-item'}
                nextLinkClassName={'page-link'}
                breakClassName={'page-item'}
                breakLinkClassName={'page-link'}
                activeClassName={'active'}
              />
            </div>
          </div> */}
          {/* game card   */}

          {isLoading ? (
            <div className="text-center">
              <div className="loaderReturn" style={{ zIndex: "99" }}>
                <img
                  src={"/images/LandingPage_img/loader1.gif"}
                  style={{ width: "100%" }}
                />
              </div>
              {/* Add any loading spinner or animation here */}
            </div>
          ) : game && game.length == 0 ? (
            <div className="text-center not_found_box_main">
              <img
                src="./images/not-found.gif"
                alt="no data"
                // width={300}
                // height={300}
                // className='img-fluid'
                // style={{ marginTop: '25%' }}
              />
              <div className="mt-2">
                <h3 className="font-weight-bold">No Game History</h3>
                <p>You have no game history yet.</p>
              </div>
            </div>
          ) : (
            game &&
            game.map((card) => (
              <>
                <div className="gameHistoryCard">
                  <div className="gameHeader">
                    <div className="gameIcon">
                      <img
                        src="./timetable.png"
                        alt=""
                        style={{ width: "22px", height: "22px" }}
                      />
                    </div>

                    <div className="gameInfo">
                      <h6>
                        {card.Status === "completed"
                          ? card?.Winner && card?.Winner?._id === user?._id
                            ? "🏆 Victory"
                            : "❌ Defeat"
                          : card?.Status}
                      </h6>

                      <span>
                        {dateFormat(card?.createdAt).split(",")[0]} •{" "}
                        {dateFormat(card?.createdAt).split(",")[1]}
                      </span>
                    </div>

                    <div
                      className={`gameResult ${
                        card?.Winner?._id === user?._id ? "gameWin" : "gameLoss"
                      }`}
                    >
                      ₹{card?.winnAmount}
                    </div>
                  </div>

                  <div className="gameBody">
                    <div className="gameRow">
                      <span>Player</span>
                      <strong>
                        {card?.Accepetd_By &&
                        card?.Accepetd_By?._id === user?._id
                          ? card.Created_by?.Name
                          : card?.Accepetd_By?.Name}
                      </strong>
                    </div>

                    <div className="gameRow">
                      <span>Game Amount</span>
                      <strong>₹{card?.Game_Ammount}</strong>
                    </div>

                    <div className="gameRow">
                      <span>Closing Balance</span>
                      <strong>
                        ₹
                        {card?.Winner?._id === user._id
                          ? card?.Winner_closingbalance
                          : card?.Loser_closingbalance}
                      </strong>
                    </div>
                  </div>

                  <div className="gameFooter">
                    {card?.Winner?._id === user._id ? (
                      <span className="winText">Won ₹{card?.winnAmount}</span>
                    ) : card.Winner ? (
                      <span className="lossText">Lost ₹{card?.winnAmount}</span>
                    ) : (
                      <span className="cancelText">Match Cancelled</span>
                    )}
                  </div>
                </div>
              </>
            ))
          )}
        </div>
      </div>

      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Gamehistory;
